import React from 'react';
export const ConfirmationModalTestIds = {
    root: 'confirmation-modal-root',
    title: 'confirmation-modal-title',
    subtitle: 'confirmation-modal-subtitle',
    content: 'confirmation-modal-content',
    closeButton: 'confirmation-modal-close-btn',
    primaryButton: 'confirmation-modal-primary-btn',
    secondaryButton: 'confirmation-modal-secondary-btn'
};
